import React, { useState } from 'react';

import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useConsolidationSummaryStudents } from '@/features/dashboard/api/getConsolidationSummaryStudents';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import { TitlePages } from '@/components/Base/TitlePage';
import Thermometer from '@/components/Base/Thermometer';
import { useTermometroFinanceiroDetalhes } from '@/features/termometro/getTermometroFinanceiroDetalhes';
import KpiComponentGreen from '@/components/Base/KpiComponentGreen';
import { useRaioxAlunos } from '@/features/raiox-alunos/api/getRaioxAlunos';
import { useRaioxAlunosDetail } from '@/features/raiox-alunos/api/getRaioxAlunosDetail';

export const TermometroRaioxAluno = () => {
  const getPositionFromScore = (month_score) => {
    if (month_score >= 0 && month_score < 3.33) {
      return 'end';
    } else if (month_score >= 3.33 && month_score < 6.66) {
      return 'center';
    } else if (month_score >= 6.66 && month_score <= 10) {
      return 'start';
    } else {
      return 'end';
    }
  };

  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const location = useLocation();
  const { id, name } = location.state || {};

  const { data: summary, isError, refetch, isFetching, isFetched } = useRaioxAlunosDetail({ id });

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)} />
          <TitlePages title={'Raio-X por aluno'} />
        </Stack>

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            sx={{
              p: '0 15px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '30px',
              color: '#fff !important',
              weight: '700',
              background: '#15AB51',
              fontWeight: 700,
              textTransform: 'capitalize',
            }}
            variant="contained"
            onClick={() => navigate('/recomendacoes-alunos-raiox', { state: { id, name } })}
          >
            Visualizar recomendações
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack
            flexDirection="row"
            gap="8px"
            style={{
              overflowX: 'auto',
              scrollBehavior: 'smooth',
              scrollbarWidth: 'thin',
              scrollbarColor: '#888 #f1f1f1',
            }}
          >
            <KpiComponentGreen title={'Score geral'} value={String(summary.average_score).replace('.', ',')} />
            <KpiComponent title={'Situação'} value={summary.is_active ? 'Ativo' : 'Inativo'} />

            <KpiComponent title={'Score frequência'} value={`${summary.frequency_score}`} />
            <KpiComponent title={'Score financeiro'} value={`${summary.financial_score?.value}`} />
            <KpiComponent title={'Score pedagógico'} value={`${summary.pedagogic_score}`} />

            <KpiComponent title={'Índice de faltas'} value={`${summary.absence_index}%`} />
          </Stack>
        )}

        <Typography sx={{ mt: '20px', mb: '10px' }} fontSize={'16px'} fontWeight={700}>
          Aluno(a): <span style={{ fontWeight: 'bold' }}>
            {`${name
              ?.toLowerCase()
              .replace(/\b\w/g, (char) => char.toUpperCase())
            } | Matrículas: ${summary?.aluno?.matriculas?.join(', ')}`}
          </span>
        </Typography>
        
        {isFetching && !summary && <LoadingSummary />}

        <Box>
        {summary?.financial_score?.bolsista ? (
          <Box
            sx={{
              boxShadow: '0px 4px 4px 0px #00000040',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '80px',
              background: '#F5F5F5',
              borderRadius: '8px',
            }}
            m={'30px 0'}
            p={'20px'}
          >
            <Typography fontWeight={700} color="primary">
              Aluno bolsista
            </Typography>
          </Box>
        ) : (
          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer
              title={'Termômetro financeiro'}
              score={summary?.financial_thermometer || 0}
            />
          </Box>
        )}

          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer
              title={'Termômetro pedagógico'}
              score={summary?.pedagogic_thermometer || 0}
            />
          </Box>

          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer
              title={'Termômetro frequência'}
              score={summary?.frequency_thermometer || 0}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
